__turbopack_context__.v({
  "confirmation-message": "LabelEditor-module-scss-module__vrXjRa__confirmation-message",
  "is-shown": "LabelEditor-module-scss-module__vrXjRa__is-shown",
  "label-form": "LabelEditor-module-scss-module__vrXjRa__label-form",
  "label-input": "LabelEditor-module-scss-module__vrXjRa__label-input",
});
